import { Box, Grid, Paper, Typography } from '@mui/material';
import CustomButton from '../../common/button/commonButton';
import MessageDialog from '../../common/dialog/commonDialogBox';
import ReusableFormFields from '../../common/textfield/ReusableTextfield';
import { styles } from '../../commonStyle/formStyles';
import {
  ATTENDER_NUMBER_FIELD,
  ATTENDER_TYPE_FIELD,
  FIRST_ATTENDER_FIELDS,
  SECOND_ATTENDER_FIELDS,
} from './admissionFieldConfigs.jsx';
import useAdmissionForm from './useAdmissionForm.js';

const AdmissionAdd = () => {
  const {
    register,
    handleSubmit,
    setValue,
    control,
    errors,
    watchAttenderType,
    watchNoOfAttenders,
    admissionState,
    onSubmit,
    handleCancel,
    dialogOpen,
    dialogProps,
    handleCloseDialog,
    patientFields,
    locationFields,
    wardDeptFields,
  } = useAdmissionForm();

  const formProps = { register, errors, setValue, control };
  const isKnownAttender = watchAttenderType === '1';

  return (
    <Box sx={styles.container}>
      <Paper sx={styles.paper}>
        <Typography variant='h4' sx={styles.heading}>
          Admission Register
        </Typography>
        <Typography variant='subtitle1' sx={{ mb: 4 }}>
          Complete all fields to request an admission
        </Typography>

        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid item xs={12}>

            {/* ── Patient Information ─────────────────────────────────── */}
            <Typography variant='h6' sx={{ mb: 2 }}>
              Patient Information
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <ReusableFormFields
                  inputFields={patientFields}
                  {...formProps}
                  gridProps={{ xs: 12, lg: 6 }}
                />
              </Grid>
            </Grid>

            {/* ── Current Location ────────────────────────────────────── */}
            <Grid item xs={12}>
              <Typography variant='h6' sx={{ mb: 2 }}>
                Current Location
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <ReusableFormFields
                    inputFields={locationFields}
                    {...formProps}
                    gridProps={{ xs: 12 }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <ReusableFormFields
                    inputFields={wardDeptFields}
                    {...formProps}
                    gridProps={{ xs: 12 }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* ── Attender Information ─────────────────────────────────── */}
            <Grid item xs={12}>
              <Typography variant='h6' sx={{ mb: 2 }}>
                Attender Information
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <ReusableFormFields
                    inputFields={ATTENDER_TYPE_FIELD}
                    {...formProps}
                    gridProps={{ xs: 12 }}
                  />
                </Grid>
                {isKnownAttender && (
                  <Grid item xs={12} sm={6}>
                    <ReusableFormFields
                      inputFields={ATTENDER_NUMBER_FIELD}
                      {...formProps}
                      gridProps={{ xs: 12 }}
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>

            {/* ── Attender Details ─────────────────────────────────────── */}
            {isKnownAttender && (
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  {(watchNoOfAttenders === '1' || watchNoOfAttenders === '2') && (
                    <Grid
                      item
                      xs={12}
                      sm={watchNoOfAttenders === '2' ? 6 : 12}
                    >
                      <Typography variant='h6' sx={{ mb: 2 }}>
                        First Attender Details
                      </Typography>
                      <ReusableFormFields
                        inputFields={FIRST_ATTENDER_FIELDS}
                        {...formProps}
                        gridProps={{ xs: 12 }}
                      />
                    </Grid>
                  )}

                  {watchNoOfAttenders === '2' && (
                    <Grid item xs={12} sm={6}>
                      <Typography variant='h6' sx={{ mb: 2 }}>
                        Second Attender Details
                      </Typography>
                      <ReusableFormFields
                        inputFields={SECOND_ATTENDER_FIELDS}
                        {...formProps}
                        gridProps={{ xs: 12 }}
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>
            )}

            {/* ── Actions ──────────────────────────────────────────────── */}
            <Grid item xs={12}>
              <Box sx={styles.buttonsContainer}>
                <CustomButton
                  text='Cancel'
                  variant='contained'
                  size='small'
                  onClick={handleCancel}
                  tabIndex={15}
                />
                <CustomButton
                  type='submit'
                  text='Submit'
                  variant='contained'
                  size='small'
                  tabIndex={16}
                  disabled={admissionState?.inProgress}
                  loading={admissionState?.inProgress}
                />
              </Box>
            </Grid>

          </Grid>
        </form>
      </Paper>

      <MessageDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        title={dialogProps.title}
        message={dialogProps.message}
        type={dialogProps.type}
      />
    </Box>
  );
};

export default AdmissionAdd;
